<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <BookingNav></BookingNav>
        </b-col>
      </b-row>
    </div>
    <div class="scheduler-body p-4">
      <div class="scheduler-content position-relative">
        <div id="calendarmask" class="position-absolute w-100 h-100 bg-dark" v-show="showCalendarView !== true"></div>
        <b-dropdown id="calendarView" :text="calendarView" ref="calendarView" v-show="showCalendarView">
          <b-dropdown-item class="d-inline-flex" @click="setCalendarView('Day')">
            <span class="flex-grow-1">Day</span>
            <span>D</span>
          </b-dropdown-item>
          <b-dropdown-item class="d-inline-flex" @click="setCalendarView('Week')">
            <span class="flex-grow-1">Week</span>
            <span>W</span>
          </b-dropdown-item>
          <b-dropdown-item class="d-inline-flex" @click="setCalendarView('Month')">
            <span class="flex-grow-1">Month</span>
            <span>M</span>
          </b-dropdown-item>
        </b-dropdown>
        <vue-scheduler :events="eventStore" :event-display="eventDisplay" ref="vueCalendar"
          @month-changed="monthChanged" @week-changed="weekChanged" @day-changed="dayChanged"
          @view-changed="viewChanged" @event-clicked="onClickEvent" disable-dialog>
        </vue-scheduler>
      </div>
      <b-button size="lg" variant="primary" class="add-event-button rounded-circle"
        @click="actionModal('new-class', 'create', null)">
        <img src="../../assets/images/icons/add-big.svg" alt="Add Icon Big">
      </b-button>
    </div>
    <div class="lds-spinner center-loading" v-bind:class="{ 'd-none': !isActive }">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <b-modal id="class-details" :class="schedule.color + '-header'" size="lg" :title="schedule.class_name" hide-footer>
      <b-button class="edit-class-button rounded-circle text-center"
        @click="actionModal('new-class', 'edit', schedule)">
        <img src="../../assets/images/actions/edit-white.svg" alt="Edit Icon" style="margin-top: -2px;">
      </b-button>
      <b-row>
        <b-col cols="8" class="pt-2 pr-0">
          <b-row class="qr-box py-2">
            <b-col cols="3" class="pt-4">
              <h6 class="muli-sb mt-4">QR Code</h6>
            </b-col>
            <b-col cols="3">
              <div class="qr-code-wrapper border rounded">
                <qrcode-vue :value="schedule.uuid" size="200" ref="qrcode"></qrcode-vue>
              </div>
            </b-col>
            <b-col>
              <a :href="downloadQRdata" target="_blank" :download="formattedQRFilename + '.jpg'"
                class="btn btn-secondary btn-sm">
                <img src="../../assets/images/actions/download.svg" alt="Download Button"> Download
              </a>
            </b-col>
          </b-row>
          <div class="border-top py-3 mt-3">
            <div class=" py-2">
              <h6 class="muli-sb">Schedule</h6>
              <b-row>
                <b-col cols="3">
                  <label for="date">Date</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ formattedScheduleDate }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <label for="time">Time</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ formattedStartAndEndTime }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <label for="instructor">Instructor</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ schedule.instructor_name }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <label for="category">Category</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ schedule.category_name }}</p>
                </b-col>
              </b-row>
            </div>
            <div class="border-top py-4 mt-2">
              <h6 class="muli-sb">Venue</h6>
              <b-row>
                <b-col cols="3">
                  <label for="branch">Branch</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ schedule.branch_name }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <label for="room">Room</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ schedule.room_name }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <label for="capacity">Capacity</label>
                </b-col>
                <b-col>
                  <p class="class-data">{{ schedule.capacity }}</p>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
        <b-col cols="4" class="border-left pt-4">
          <div class="py-2">
            <h6 class="muli-sb">Students</h6>
            <p v-if="this.loadingStudent">
              <small>loading...</small>
            </p>
            <div v-else-if="!this.loadingStudent && attendees">
              <p class="student" v-for="student in attendees" :key="student.customer_uuid">{{
          student.firstname + " " + student.lastname }}
              </p>
            </div>
            <div v-else-if="!this.loadingStudent && !attendees">
              <p class="student">
                No Students Enrolled
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="new-class" size="lg" :title="action === 'create' ? 'Add New Schedule' : 'Edit Schedule'">
      <div v-if="!formLoaded" style="text-align: center">
        Loading form...
      </div>
      <div v-else id="add-new-class" class="modal-form">
        <b-row no-gutters>
          <b-col sm="12" md="3">
            <h6 class="main-label">Class</h6>
          </b-col>
          <b-col>
            <b-form-group id="classNameGroup" label-for="className" label="Class Name" class="secondary-label"
              :invalid-feedback="errorMessage('class_id')" :state="isValid('class_id')">
              <b-form-select id="className" v-model="form.selectedClassName" :options="form.classNameOptions" />
            </b-form-group>
            <b-form-group id="instructorGroup" label-for="instructor" label="Instructor" class="secondary-label"
              :invalid-feedback="errorMessage('instructor_id')" :state="isValid('instructor_id')">
              <b-form-select id="instructor" v-model="form.selectedInstructor" :options="form.instructorOptions" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <hr class="form-divider">
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col sm="12" md="3">
            <h6 class="main-label">Color</h6>
          </b-col>
          <b-col>
            <b-form-group id="scheduleColorGroup" label-for="scheduleColor" label="Schedule Color"
              class="secondary-label">
              <b-form-select id="scheduleColor" v-model="form.selectedScheduleColor"
                :options="form.scheduleColorOptions" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <hr class="form-divider">
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col sm="12" md="3">
            <h6 class="main-label">Schedule</h6>
          </b-col>
          <b-col>
            <b-row no-gutters>
              <b-col>
                <b-form-group class="mb-1">
                  <label for="date" class="secondary-label align-top">Date <small style="color: orange"
                      v-if="action === 'edit'"><i>(
                        will only apply to this schedule )</i></small></label>
                  <div class="custom-datepicker mb-3 muli-sb">
                    <SingleDatepicker :bootstrap-styling="true" :value="form.date" ref="programaticOpen"
                      v-model="form.date" wrapper-class="custom-datepicker" style="color: #2a2a2a !important;">
                      <div slot="afterDateInput" class="input-group-append pr-0">
                        <span class="input-group-text">
                          <img @click="openPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon"
                            class="form-icon action-button">
                        </span>
                      </div>
                    </SingleDatepicker>
                    <b-form-group class="secondary-label" :invalid-feedback="errorMessage('schedule_date')"
                      :state="isValid('schedule_date')">
                    </b-form-group>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="scheduler-timepicker">
                  <b-form-group class="secondary-label" :invalid-feedback="errorMessage('invalid_start_time')"
                    :state="isValid('invalid_start_time')">
                    <label for="start_time" class="secondary-label align-top">Start Time</label>
                    <b-input-group>
                      <b-input-group-text slot="append">
                        <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                      </b-input-group-text>
                      <vue-timepicker v-model="form.startTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                    </b-input-group>
                  </b-form-group>

                </div>
              </b-col>
              <b-col>
                <div class="scheduler-timepicker">
                  <b-form-group class="secondary-label" :invalid-feedback="errorMessage('invalid_end_time')"
                    :state="isValid('invalid_end_time')">
                    <label for="end_time" class="secondary-label align-top">End Time</label>
                    <b-input-group>
                      <b-input-group-text slot="append">
                        <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                      </b-input-group-text>
                      <vue-timepicker v-model="form.endTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                    </b-input-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="action === 'create'">
              <b-col>
                <div>
                  <label for="recurrence" class="secondary-label d-block">Recurrence</label>
                  <switches v-model="form.recurrence" theme="custom" color="primary" type-bold="true" text-enabled="On"
                    text-disabled="Off" style="top: -18px;">
                  </switches>
                  <b-form-group v-show="form.recurrence === true" class="secondary-label"
                    :invalid-feedback="errorMessage('recurring_days')" :state="isValid('recurring_days')">
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="action === 'create'" v-bind:class="{ 'd-none': !form.recurrence }">
              <b-col>
                <div class="days-container">
                  <b-form-group>
                    <b-form-checkbox-group buttons v-model="form.selectedDays" button-variant="primary" name="butons1"
                      :options="form.daysOptions">
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="action === 'create'" no-gutters v-bind:class="{ 'd-none': !form.recurrence }">
              <b-col>
                <b-form-group class="mb-0">
                  <label for="end_date" class="secondary-label align-top">End Date</label>
                  <div class="custom-datepicker mb-3 muli-sb">
                    <SingleDatepicker :bootstrap-styling="true" :value="form.endDate" ref="programaticOpen"
                      v-model="form.endDate" wrapper-class="custom-datepicker" style="color: #2a2a2a !important;">
                      <div slot="afterDateInput" class="input-group-append pr-0">
                        <span class="input-group-text">
                          <img @click="openPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon"
                            class="form-icon action-button">
                        </span>
                      </div>
                    </SingleDatepicker>
                    <b-form-group class="secondary-label" :invalid-feedback="errorMessage('end_date')"
                      :state="isValid('end_date')">
                    </b-form-group>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <hr class="form-divider">
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col sm="12" md="3">
            <h6 class="main-label">Venue</h6>
          </b-col>
          <b-col>
            <b-form-group id="branchGroup" label-for="branch" label="Branch" class="secondary-label"
              :invalid-feedback="errorMessage('branch_uuid')" :state="isValid('branch_uuid')">
              <b-form-select id="branch" @input="filterRooms" v-model="form.selectedBranch"
                :options="form.branchOptions" />
            </b-form-group>
            <b-form-group id="roomGroup" label-for="room" label="Room" class="secondary-label">
              <b-form-select id="room" v-model="form.selectedRoom" :options="form.roomOptions" />
            </b-form-group>
            <b-form-group class="secondary-label" :invalid-feedback="errorMessage('capacity')"
              :state="isValid('capacity')">
              <label for="capacity" class="secondary-label align-top">Capacity</label>
              <div class="form-inline mb-3">
                <b-form-input v-model="form.capacity" type="number" min="1" :formatter="capacityFormatter" step="1"
                  placeholder="1" style="width: 164px;">
                </b-form-input>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <hr class="form-divider">
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="3">
            <h6 class="main-label">Visibility</h6>
          </b-col>
          <b-col>
            <div>
              <label for="publish_in_app" class="secondary-label d-block">Publish in app</label>
              <switches v-model="form.visibility" theme="custom" disabled color="primary" type-bold="true"
                text-enabled="On" text-disabled="Off" style="top: -18px;">
              </switches>
            </div>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer">
        <b-button v-if="formLoaded" variant="ghost" @click="cancel" class="btn-cancel" style="margin-right: .25rem;">
          Cancel
        </b-button>
        <b-button v-if="formLoaded" @click="saveSchedule" variant="primary" style="margin-left: .25rem;">
          {{ saving ? 'Saving...' : 'Save' }}
        </b-button>
      </div>
    </b-modal>
    <b-modal no-close-on-esc no-close-on-backdrop hide-header-close id="apply-changes" title="Apply Changes">
      <p v-if="!saving" class="modal-main-message">Do you want to apply your changes to <strong>succeeding schedule
        </strong>?</p>
      <p v-else class="modal-main-message">Applying changes, please wait...</p>
      <div slot="modal-footer">
        <b-btn variant="secondary" :disabled="saving" class="mr-1" @click="applyChanges(false)">
          No, only to this schedule
          <i v-if="saving && !updateSucceeding" class="ml-1"> <img width="15" height="15"
              src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
          </i>
        </b-btn>
        <b-btn variant="secondary" :disabled="saving" class="ml-1" @click="applyChanges(true)">
          Yes, apply
          <i v-if="saving && updateSucceeding" class="ml-1"> <img width="15" height="15"
              src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
          </i>
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "../../plugins/calendar-scheduler";
import BookingNav from "./BookingNav.vue";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import Datepicker from "vue-bulma-datepicker";
import Switches from "vue-switches";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { mapState } from "vuex";
import _ from "lodash";
import QrcodeVue from 'qrcode.vue';

require("vue-simple-calendar/static/css/default.css");

export default {
  name: "scheduler",
  data() {
    return {
      isActive: false,
      saving: false,
      action: null,
      activeSchedule: null,
      isCreatingSchedule: true,
      loadingStudent: false,
      showDate: new Date(),
      updateSucceeding: false,
      showCalendarView: false,
      calendarView: "Month",
      dateNow: null,
      downloadQRdata: ""
    };
  },
  components: {
    BookingNav,
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    Switches,
    SingleDatepicker,
    VueTimepicker,
    QrcodeVue
  },
  computed: {
    ...mapState("bookingScheduler", [
      "schedules",
      "schedule",
      "attendees",
      "eventStore",
      "classOptions",
      "instructorOptions",
      "branchOptions",
      "roomOptions",
      "errors",
      "loading",
      "form",
      "formLoaded",
      "errors",
      "rooms"
    ]),
    formattedScheduleDate: {
      get: function () {
        return this.$moment(
          this.schedule.schedule_date,
          "YYYY-MM-DD"
        ).format("MMM. DD, YYYY");
      }
    },
    formattedStartAndEndTime: {
      get: function () {
        let st = this.$moment(
          this.schedule.start_time,
          "hh:mm:ss"
        ).format("hh:mm A");
        let et = this.$moment(
          this.schedule.end_time,
          "hh:mm:ss"
        ).format("hh:mm A");
        return st + " to " + et;
      }
    },
    formattedQRFilename: {
      get: function () {
        let class_name = this.schedule.qrfilename;
        let date = this.$moment(
          this.schedule.schedule_date,
          "YYYY-MM-DD"
        ).format("YYYYMMDD");
        let time = this.$moment(
          this.schedule.start_time,
          "hh:mm:ss"
        ).format("Hmm");
        return class_name + "_" + date + "-" + time;
      }
    }
  },
  created: async function () {
    await this.initPage();
    this.applyEventColor();
    this.repositionCalendarViewOption();
  },
  methods: {
    async initPage() {
      await this.getFormOptions();
      await this.initForm();
    },
    async initForm() {
      await this.$store.dispatch("bookingScheduler/initForm").then(() => {
        this.filterRooms();
      });
    },
    async getFormOptions() {
      await this.$store.dispatch("bookingScheduler/getClassOptions");
      await this.$store.dispatch("bookingScheduler/getInstructorOptions");
      await this.$store.dispatch("bookingScheduler/getBranchOptions");
      await this.$store
        .dispatch("bookingScheduler/getRoomOptions")
        .then(() => {
          this.form.loaded = true;
        });
    },
    async actionModal(modal, action, schedule) {
      this.activeSchedule = schedule;
      this.action = action;
      await this.$store.commit("bookingScheduler/errors", null);
      if (this.action === "edit") {
        await this.initializedEditFormData();
      }
      this.showModal(modal);
    },
    initializedEditFormData() {
      let editForm = this.form;
      editForm.date = this.activeSchedule.schedule_date;
      let st = this.activeSchedule.start_time.split(":");
      let start_time = {
        HH: st[0],
        mm: st[1],
        ss: st[2]
      };
      let et = this.activeSchedule.end_time.split(":");
      let end_time = {
        HH: et[0],
        mm: et[1],
        ss: et[2]
      };
      editForm.startTime = start_time;
      editForm.endTime = end_time;
      editForm.selectedScheduleColor = this.activeSchedule.color;
      editForm.selectedClassName = this.activeSchedule.class_id;
      editForm.selectedBranch = this.activeSchedule.branch_uuid;
      editForm.selectedBranchName = this.activeSchedule.branch_name;
      editForm.selectedInstructor = this.activeSchedule.instructor_id;
      editForm.selectedRoom = this.activeSchedule.room_id;
      editForm.capacity = this.activeSchedule.capacity;
      editForm.visibility = this.activeSchedule.visibility === 1;

      this.$store.commit("bookingScheduler/form", editForm);
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    setShowDate(d) {
      this.showDate = d;
    },
    capacityFormatter(value, event) {
      return event === null
        ? value
        : value.replace(/\./gi, "").substring(0, 4);
    },
    onClickEvent(e) {
      this.isActive = true;
      this.loadingStudent = true;
      this.$store
        .dispatch("bookingScheduler/viewSchedule", e.uuid)
        .then(() => {
          this.isActive = false;
          this.$root.$emit("bv::show::modal", "class-details");
          this.$store
            .dispatch(
              "bookingScheduler/getAttendees",
              this.schedule.uuid
            )
            .then(() => {
              this.loadingStudent = false;
              this.generateQRjpg();
            });
        });
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
    async filterRooms() {
      let rooms = [];
      let _this = this;
      await _.forEach(this.rooms, function (value) {
        let object = {
          value: value.id,
          text: value.name
        };
        if (_this.form.selectedBranch === value.branch_uuid) {
          rooms.push(object);
        }
      });

      if (rooms.length > 0) {
        this.form.roomOptions = rooms;
        this.form.selectedRoom = rooms[0].value;
      } else {
        this.form.roomOptions = [];
        this.form.selectedRoom = null;
      }
    },
    cancel() {
      if (this.saving) {
        return false;
      }
      this.hideModal("new-class");
      this.saving = false;
    },
    async saveSchedule() {
      if (this.action === "create") {
        if (this.saving) {
          return false;
        }
        this.saving = true;
        await this.createSchedule();
      }

      if (this.action === "edit") {
        await this.editSchedule();
      }
    },
    async createSchedule() {
      let data = {};
      data.class_id = this.form.selectedClassName;
      data.instructor_id = this.form.selectedInstructor;
      data.branch_uuid = this.form.selectedBranch;
      data.branch_name = this.form.selectedBranchName;
      let _this = this;
      if (data.branch_uuid !== null) {
        let branch = _.find(_this.branchOptions, function (o) {
          return o.value === data.branch_uuid;
        });
        data.branch_name = branch !== undefined ? branch.text : null;
      }
      data.room_id = this.form.selectedRoom;
      data.color = this.form.selectedScheduleColor;
      let parseScheduleDate = this.$moment(this.form.date, "L").format(
        "YYYY-MM-DD"
      );
      data.schedule_date =
        parseScheduleDate !== "Invalid date"
          ? this.$moment(
            this.form.date.toLocaleDateString(),
            "L"
          ).format("YYYY-MM-DD")
          : this.form.date;
      let st = this.form.startTime;
      data.start_time = st.HH + ":" + st.mm + ":" + st.ss;
      let et = this.form.endTime;
      data.end_time = et.HH + ":" + et.mm + ":" + et.ss;
      data.capacity = this.form.capacity;
      data.visibility = this.form.visibility;

      data.is_recurring = this.form.recurrence;
      let parseEndDate = this.$moment(this.form.endDate, "L").format(
        "YYYY-MM-DD"
      );
      data.end_date =
        parseEndDate !== "Invalid date"
          ? this.$moment(
            this.form.endDate.toLocaleDateString(),
            "L"
          ).format("YYYY-MM-DD")
          : this.form.endDate;
      data.recurring_days =
        this.form.selectedDays.length > 0
          ? this.form.selectedDays
          : null;
      this.$store
        .dispatch("bookingScheduler/createSchedule", data)
        .then(async () => {
          this.saving = false;
          this.isActive = true;
          //Don't update the state non affected schedules
          this.$store.commit("bookingScheduler/forceUpdate", false);

          let calendar_view = await this.calendarView;

          this.$store.commit("bookingScheduler/setCalendarView", calendar_view);
          let getEvents = null;
          switch (calendar_view) {
            case "Month":
              getEvents = this.$moment(
                data.schedule_date,
                "YYYY-MM-DD"
              ).format("YYYY-MM");
              break;
            case "Day":
              getEvents = this.$moment(
                data.schedule_date,
                "YYYY-MM-DD"
              ).format("YYYY-MM-DD");
              break;
            case "Week":
              getEvents = this.dateNow
              break;
          }
          this.$store.dispatch("bookingScheduler/clearEventStore")
            .then(() => {
              this.$store
                .dispatch(
                  "bookingScheduler/refreshCalendar",
                  getEvents
                )
                .then(() => {
                  this.isActive = false;
                });
            });

          if (this.errors === null) {
            this.saving = false;
            this.hideModal("new-class");
          }
        });
    },
    async editSchedule() {
      this.showModal("apply-changes");
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return !this.errors.errors[field];
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }

      return this.errors.errors[field];
    },
    applyChanges(applyToSucceeding) {
      if (this.saving) {
        return false;
      }
      this.updateSucceeding = applyToSucceeding;
      this.saving = true;
      let data = {};
      data.uuid = this.activeSchedule.uuid;
      data.class_id = this.form.selectedClassName;
      data.instructor_id = this.form.selectedInstructor;
      data.branch_uuid = this.form.selectedBranch;
      data.branch_name = this.form.selectedBranchName;
      let _this = this;
      if (data.branch_uuid !== null) {
        let branch = _.find(_this.branchOptions, function (o) {
          return o.value === data.branch_uuid;
        });
        data.branch_name = branch !== undefined ? branch.text : null;
      }
      data.room_id = this.form.selectedRoom;
      data.color = this.form.selectedScheduleColor;
      let parseScheduleDate = this.$moment(this.form.date, "L").format(
        "YYYY-MM-DD"
      );
      data.schedule_date =
        parseScheduleDate !== "Invalid date"
          ? this.$moment(
            this.form.date.toLocaleDateString(),
            "L"
          ).format("YYYY-MM-DD")
          : this.form.date;
      let st = this.form.startTime;
      data.start_time = st.HH + ":" + st.mm + ":" + st.ss;
      let et = this.form.endTime;
      data.end_time = et.HH + ":" + et.mm + ":" + et.ss;
      data.capacity = this.form.capacity;
      data.visibility = this.form.visibility;

      data.is_recurring = false;
      data.end_date = this.form.endDate;
      data.update_succeeding = applyToSucceeding;

      this.$store
        .dispatch("bookingScheduler/updateSchedule", data)
        .then(async () => {
          this.saving = false;
          this.isActive = true;
          //Force update the state affected schedules
          this.$store.commit("bookingScheduler/forceUpdate", true);

          let calendar_view = await this.calendarView;

          this.$store.commit("bookingScheduler/setCalendarView", calendar_view);
          let getEvents = null;
          switch (calendar_view) {
            case "Month":
              getEvents = this.$moment(
                data.schedule_date,
                "YYYY-MM-DD"
              ).format("YYYY-MM");
              break;
            case "Day":
              getEvents = this.$moment(
                data.schedule_date,
                "YYYY-MM-DD"
              ).format("YYYY-MM-DD");
              break;
            case "Week":
              getEvents = this.dateNow
              break;
          }

          this.$store.dispatch("bookingScheduler/clearEventStore")
            .then(async () => {
              this.$store
                .dispatch(
                  "bookingScheduler/refreshCalendar",
                  getEvents
                )
                .then(() => {
                  this.isActive = false;
                });
            });

          if (this.errors === null) {
            this.saving = false;
            this.hideModal("apply-changes");
            this.hideModal("new-class");
          } else {
            this.showModal("new-class");
            this.hideModal("apply-changes");
          }
        });
    },
    /* Vue Calendar */
    eventDisplay: function (event) {
      return event.name + "&##" + event.classes;
    },
    async getCalendarEventsM(yearMonth) {
      this.isActive = true;
      await this.$store
        .dispatch("bookingScheduler/getSchedulesByMonth", yearMonth)
        .then(() => {
          this.isActive = false;
        });
    },
    async getCalendarEventsW(week) {
      this.isActive = true;
      await this.$store
        .dispatch("bookingScheduler/getSchedulesByWeek", week)
        .then(() => {
          this.isActive = false;
        });
    },
    async getCalendarEventsD(day) {
      this.isActive = true;
      await this.$store
        .dispatch("bookingScheduler/getSchedulesByDay", day)
        .then(() => {
          this.isActive = false;
        });
    },
    monthChanged: async function (newDate) {
      let date = this.$moment(
        newDate.toLocaleDateString(),
        "L"
      ).format("YYYY-MM");
      await this.$store.dispatch("bookingScheduler/clearEventStore")
        .then(() => {
          this.dateNow = date;
          this.getCalendarEventsM(date);
        });
      this.applyEventColor();
    },
    weekChanged: async function (newDate) {
      let date = this.$moment(
        newDate.toLocaleDateString(),
        "L"
      ).format("YYYY-MM-DD");
      await this.$store.dispatch("bookingScheduler/clearEventStore")
        .then(() => {
          this.dateNow = date;
          this.adjustWeekStartDay(newDate);
        });
    },
    dayChanged: async function (newDate) {
      let date = this.$moment(
        newDate.toLocaleDateString(),
        "L"
      ).format("YYYY-MM-DD");
      await this.$store.dispatch("bookingScheduler/clearEventStore")
        .then(() => {
          this.dateNow = date;
          this.getCalendarEventsD(date);
          this.applyEventColor();
        });
    },
    viewChanged: async function (newView) {
      await newView;
      let activeDate = this.$refs.vueCalendar.activeDate;
      let day = activeDate._d;
      switch (newView) {
        case "day":
          this.dayChanged(day);
          this.dateNow = this.$moment(
            day.toLocaleDateString(),
            "L"
          ).format("YYYY-MM-DD");
          break;
        case "week":
          this.adjustWeekStartDay(day);
          break;
        case "month":
          await this.$store.dispatch("bookingScheduler/clearEventStore")
            .then(() => {
              let newMonthDate = this.$moment(
                day
              ).format("YYYY-MM");
              this.dateNow = newMonthDate;
              this.getCalendarEventsM(newMonthDate);
              this.applyEventColor();
            });
          break;
      }
    },
    computeWeekStartDay: async function (day, dayNum, year, month) {
      let newDate = (this.$moment(day).format("DD") - dayNum).toLocaleString("en-US", { minimumIntegerDigits: 2 });
      if (newDate < 0) {
        let dateDiff = (0 - newDate).toLocaleString("en-US", { minimumIntegerDigits: 2 });
        month = (this.$moment(day).format("MM") - 1).toLocaleString("en-US", { minimumIntegerDigits: 2 });
        newDate = new Date(year, month, 0).getDate() - dateDiff;
      } else if (newDate === "00") {
        month = (month - 1).toLocaleString("en-US", { minimumIntegerDigits: 2 });
        newDate = new Date(year, month, 0).getDate();
      }
      if (month === "00") {
        month = Number(month + 1).toLocaleString("en-US", { minimumIntegerDigits: 2 });
      }
      await this.$store.dispatch("bookingScheduler/clearEventStore")
        .then(() => {
          this.dateNow = year + "-" + month + "-" + newDate;
          this.getCalendarEventsW(this.dateNow);
          this.applyEventColor();
        });
    },
    adjustWeekStartDay: async function (day) {
      await day;
      let dddd = this.$moment(day).format("dddd");
      let year = this.$moment(day).format("YYYY");
      let month = this.$moment(day).format("MM");
      switch (dddd) {
        case "Monday":
          this.computeWeekStartDay(day, 1, year, month);
          break;
        case "Tuesday":
          this.computeWeekStartDay(day, 2, year, month);
          break;
        case "Wednesday":
          this.computeWeekStartDay(day, 3, year, month);
          break;
        case "Thursday":
          this.computeWeekStartDay(day, 4, year, month);
          break;
        case "Friday":
          this.computeWeekStartDay(day, 5, year, month);
          break;
        case "Saturday":
          this.computeWeekStartDay(day, 6, year, month);
          break;
        case "Sunday":
          this.computeWeekStartDay(day, 0, year, month);
          break;
      }
    },
    applyEventColor: async function () {
      let events = await this.eventStore;
      let eventBubble = document.querySelectorAll(".v-cal-event-item");
      for (let i = 0; events.length > i; i++) {
        if (eventBubble.length > 0) {
          let eventClass = await eventBubble[i].title.split("&##")[1];
          let eventIds = await eventBubble[i].title.replace(/ /g, "_");
          await eventBubble[i].setAttribute("id", eventIds + "_" + i);
          if (eventBubble[i].attributes.id.value === eventIds + "_" + i) {
            eventBubble[i].classList.add(eventClass);
            let newTitle = await eventBubble[i].title.split("&##")[0].split(" - ")[1];
            eventBubble[i].children[1].innerHTML = await newTitle;
            eventBubble[i].onmouseover = () => {
              event.target.title = newTitle;
            }
          }
        }
      }
    },
    repositionCalendarViewOption: function () {
      let right_actions = document.querySelector(".actions-right");
      right_actions.appendChild(this.$refs.calendarView.$el);
      this.showCalendarView = true;
    },
    setCalendarView: function (view) {
      this.calendarView = view;
      let right_actions = document.querySelector(".actions-right");
      switch (view) {
        case "Day":
          right_actions.children[2].click();
          break;
        case "Week":
          right_actions.children[1].click();
          break;
        case "Month":
          right_actions.children[0].click();
          break;
      }

    },
    /*== Generate QR ==*/
    generateQRjpg: function () {
      let canvas = this.$refs.qrcode.$refs["qrcode-vue"];

      let image = canvas.toDataURL("image/jpg");
      this.downloadQRdata = image;
    }
  },
  watch: {
    isActive: async function (value) {
      let status = await value;
      if (status === false) {
        this.applyEventColor();
      }
    },
    dateNow: async function (value) {
      await value;
    }
  }
};
</script>
<style lang="scss">
@import "../../../node_modules/v-calendar-scheduler/lib/main.css";
</style>
